import { render, staticRenderFns } from "./invoicDetail.vue?vue&type=template&id=dc494506&scoped=true"
import script from "./invoicDetail.vue?vue&type=script&lang=js"
export * from "./invoicDetail.vue?vue&type=script&lang=js"
import style0 from "./invoicDetail.vue?vue&type=style&index=0&id=dc494506&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc494506",
  null
  
)

export default component.exports